<template lang="html">
  <si-container>
    <v-flex>
      <v-layout>
        <v-flex
          xs12
          md8
        >
          <v-card>
            <v-card-title>
              Testimonials
              <v-spacer />
              <v-btn
                depressed
                color="primary"
                @click="createNew"
              >
                Create
              </v-btn>
            </v-card-title>
            <v-divider v-if="testimonialsList.length > 0" />
            <Container
              class="v-list"
              group-name="list"
              :get-child-payload="i => {return testimonialsList[i]}"
              @drop="e => onDrop('list', e)" 
            >
              <Draggable
                v-for="t in testimonialsList"
                :key="t.id"
              >
                <v-list-item @click="editTestimonial(t.id)">
                  <v-list-item-avatar>
                    <v-img
                      v-if="(t.avatar || {}).src"
                      :src="(t.avatar || {}).src"
                    />
                    <v-icon
                      v-else
                      color="teal"
                    >
                      format_quote
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="t.name" />
                    <v-list-item-subtitle v-text="t.title" />
                    <v-list-item-subtitle v-text="t.text" />
                  </v-list-item-content>
                  <v-list-item-action>
                    <SiDeleteButton
                      title="Delete testimonial"
                      message="Are you sure you want to delete this testimonial"
                      @delete="deleteTestimonial(t.id)"
                    />
                  </v-list-item-action>
                </v-list-item>
              </Draggable>
            </Container>
          </v-card>
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-layout wrap>
            <v-flex xs12>
              <v-card>
                <v-card-subtitle>
                  <v-icon left>
                    recent_actors
                  </v-icon>
                  Home page
                </v-card-subtitle>
                <Container
                  class="v-list v-dense"
                  group-name="home"
                  :get-child-payload="i => {return testimonialsList[i]}"
                  :should-accept-drop="(src, payoad) => shouldAcceptDrop('home', src, payoad)" 
                  @drop="e => onDrop('home', e)"
                >
                  <Draggable
                    v-for="t in diplayGroup('home')"
                    :key="t.id"
                  >
                    <div>
                      <v-list-item>
                        <v-list-item-avatar>
                          <v-img :src="(t.avatar || {}).src" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title v-text="t.name" />
                          <v-list-item-subtitle v-text="t.title" />
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            icon
                            @click="removeItem('home', t.id)"
                          >
                            <v-icon small>
                              close
                            </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </div>
                  </Draggable>
                </Container>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-subtitle>
                  <v-icon left>
                    recent_actors
                  </v-icon>
                  Services page
                </v-card-subtitle>                    <Container
                  class="v-list"
                  group-name="services"
                  :get-child-payload="i => {return testimonialsList[i]}"
                  :should-accept-drop="(src, payoad) => shouldAcceptDrop('services', src, payoad)" 
                  @drop="e => onDrop('services', e)"
                >
                  <Draggable
                    v-for="t in diplayGroup('services')"
                    :key="t.id"
                  >
                    <v-list-item>
                      <v-list-item-avatar>
                        <v-img :src="(t.avatar || {}).src" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="t.name" />
                        <v-list-item-subtitle v-text="t.title" />
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          icon
                          @click="removeItem('services', t.id)"
                        >
                          <v-icon small>
                            close
                          </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </Draggable>
                </Container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-dialog
      v-model="dialog"
      max-width="800"
      scrollable
    >
      <v-card>
        <v-card-title primary-title>
          {{ edit.name }}
          <v-spacer />
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="pb-12 text-center">
            <v-avatar
              :size="130"
              color="white"
            >
              <SiImage
                :image.sync="edit.avatar"
                :save-path="`assets`"
                border
              />
            </v-avatar>
          </div>
          <v-layout ma-n2>
            <v-flex
              xs12
              sm6
              pa-2
            >
              <SiInputText
                v-model="edit.name"
                label="Name"
                outlined
              />
            </v-flex>
            <v-flex
              xs12
              sm6
              pa-2
            >
              <SiInputText
                v-model="edit.title"
                label="Title"
                outlined
              />  
            </v-flex>
          </v-layout>
          <SiInputText
            v-model="edit.businessName"
            label="Business name"
            outlined
          />
          <SiInputText
            v-model="edit.businessLink"
            label="Business website"
            outlined
          />
          <SiInputTextarea
            v-model="edit.text"
            label="Text"
            outlined
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="grey"
            :disabled="editSaving"
            @click="cancelEdit"
          >
            Cancel
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :loading="editSaving"
            @click="saveEdit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </si-container>
</template>

<script>
import helpers from "@/mixins/helpers";
import binder from "@/mixins/binder";
import { Container, Draggable } from "vue-smooth-dnd";
import { rtdb, storage } from '@/plugins/firebase'
import uniqid from 'uniqid'
export default {
  components: {
    Container,
    Draggable,
  },
  mixins: [helpers, binder],
  data() {
    return {
      testimonials: {},
      displayGroups: {},
      edit: {}, 
      editIsNew: false,
      editSaving: false,
      dialog: false,
    };
  },
  computed: {
    testimonialsList() {
      return this._sortObject(this.testimonials);
    },
    diplayGroupsPath () {
      return "site/testimonials/displayGroups"
    },
    testimonialsPath () {
      return "site/testimonials/items"
    }
  },
  watch: {
    dialog(v) {
      if (!v) this.edit = {}
    }
  },
  beforeMount() {
    this.$store.commit("set_appBarTitle", {
      title: "Testimonials",
      icon: "reviews",
    });
    this.$bindRtdb("displayGroups", this.diplayGroupsPath, { loader: true });
    this.$bindRtdb("testimonials", this.testimonialsPath, { loader: true });
  },
  methods: {
    onDrop(groupName, event) {
      if (groupName === 'list') return

      let index = this.displayGroups[groupName] || []
      
      if (event.addedIndex !== null) {
        if (event.removedIndex !== null) {
          index = this._arrayMove(index, event.removedIndex, event.addedIndex)
        } else {
          index.splice(event.addedIndex, 0, event.payload.id);
        }
        this.$set(this.displayGroups, groupName, [ ...new Set(index) ])
        this.saveDisplayGroups()
      }
    }, 
    removeItem (groupName, removedId) {
      let index = this.displayGroups[groupName].filter(id => id !== removedId)
      this.$set(this.displayGroups, groupName, index)
      this.saveDisplayGroups()
    },
    saveDisplayGroups () {
      rtdb.ref("site/testimonials/displayGroups").set(this.displayGroups)
    },
    diplayGroup (groupName) {
      let index = this.displayGroups[groupName]
      return index 
        ? index.map(id => this.testimonials[id]).filter(t => t)
        : []
    },
    shouldAcceptDrop(groupName, src, payload) {
      let index = this.displayGroups[groupName] || []
      let canDropFromList = src.groupName === "list" && !index.includes(payload.id)
      let isSelfMove = src.groupName === groupName
      return canDropFromList || isSelfMove
    },
    createNew () {
      this.edit = { id: uniqid() }
      this.editIsNew = true
      this.dialog = true
    },
    editTestimonial (id) {
      this.edit = { ...this.testimonials[id] }
      this.editIsNew = false
      this.dialog = true
    },
    cancelEdit () {
      if (this.edit.avatar && this.editIsNew) {
        storage.ref(this.edit.avatar.path).delete()
      }
      this.edit = {}
      this.dialog = false
    },
    async saveEdit () {
      this.editSaving = true
      
      await rtdb.ref(`${this.testimonialsPath}/${this.edit.id}`).set(this.edit)

      this.editSaving = false
      this.edit = {}
      this.dialog = false
    },
    deleteTestimonial (id) {
      if (this.testimonials[id].avatar) {
        storage.ref(this.testimonials[id].avatar.path).delete()
      }
      rtdb.ref(`${this.testimonialsPath}/${id}`).set(null)
      Object
          .keys(this.displayGroups)
          .forEach(groupName => {
            let index = this.displayGroups[groupName]
            this.$set(this.displayGroups, groupName, [ ...index.filter(i => i !== id) ])
          })
      this.saveDisplayGroups()
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
